import React from 'react';
import { TransactionData } from '../types';
import { IdView } from '../../../../components';

interface TransactionIdCellProps {
  transaction: TransactionData;
}

const TransactionIdCell: React.FC<TransactionIdCellProps> = ({ transaction }) => {
  return <IdView textToCopy={transaction.id}>{transaction.id?.slice(-4)}</IdView>;
};

export default TransactionIdCell;
